module.exports = __webpack_public_path__ + "img/paypal.d2846f15.png";